import styled from 'styled-components';
import { Button } from 'global/styles/styles.js';

const S = {};

S.MultiCouponWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

S.MultiCouponBlockLabelWrapper = styled.div`
    flex: 1 0 auto;
    display: flex;
    margin-right: 32px;
`;

S.MultiCouponBlockLabelSeparator = styled.div`
    flex: 5 0 0;
`;

S.MultiCouponBlockLabelStake = styled.div`
    flex: 1 0 0;
    color: #000;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
`;

S.MultiCouponBlockLabelWin = styled.div`
    flex: 1 0 0;
    color: #000;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
`;

S.MultiCouponBlockWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px 10px;
    border-radius: 4px;
    background-color: #FFF;
`;

S.MultiCouponBlockHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

S.MultiCouponBlockHeaderTypeWrapper = styled.div`
    flex: 5 0 0;
    display: flex;
    align-items: center;
    gap: 6px;
`;

S.MultiCouponBlockHeaderTypeLabel = styled.div`
    color: #262626;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.07px;
`;

S.MultiCouponBlockHeaderInfoStake = styled.div`
    flex: 1 0 0;
    color: #262626;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
`;

S.MultiCouponBlockHeaderInfoWin = styled.div`
    flex: 1 0 0;
    color: #262626;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
`;

S.MultiCouponBlockHeaderInfoExpand = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background-image: url(/images/chevron_down_dark.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px;
    rotate: ${({ isExpanded }) => isExpanded ? `180deg` : '0deg'};
`;

S.StatusIcon = styled.div`
    &.details_lost,
    &.details_won,
    &.details_placed,
    &.details_cancel,
    &.details_cashouted {
        height: 2rem;
        width: 2rem;
        border-radius: 20px;
        background: none;
    }
    &.details_lost {
        background-image: url(/images/svg/lost-24px.svg);
    }
    &.details_won {
        background-image: url(/images/svg/win-24px.svg);
    }
    &.details_placed {
        background-image: url(/images/svg/placed-24px.svg);
        width: 1.7rem;
        background-repeat: no-repeat;
        background-position: center;
    }
    &.details_cashouted {
        background-image: url(/images/svg/cashout-24px.svg);
    }
    &.details_cancel {
        background-image: url(/images/svg/cancel-24px.svg);
        width: 1.7rem;
        background-repeat: no-repeat;
        background-position: center;
    }
`;

S.CashoutButton = styled(Button)`
    flex: 1 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px 0;
    border-radius: 4px;
    font-size: 1.33rem;
    font-weight: 700;
    text-transform: uppercase;
    color: ${({ theme: { $accountProfileBetHistoryCashoutBttnColor } }) => $accountProfileBetHistoryCashoutBttnColor};
    background-color: ${({ theme: { $accountProfileBetHistoryCashoutBttnBackground } }) => $accountProfileBetHistoryCashoutBttnBackground};
    
    &:disabled {
        color: ${({ theme: { $accountProfileBetHistoryCashoutBttnDisabledColor } }) => $accountProfileBetHistoryCashoutBttnDisabledColor};
        background-color: ${({ theme: { $accountProfileBetHistoryCashoutBttnDisabledBackground } }) => $accountProfileBetHistoryCashoutBttnDisabledBackground};
        cursor: not-allowed;
    }
`;

export default S;